import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon, InfoIcon } from 'lucide-react';
export function Pricing() {
  return <section id="cena" className="w-full bg-off-white py-24 px-6 scroll-mt-20" data-id="element-196">
      <div className="max-w-5xl mx-auto" data-id="element-197">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-198">
          <h2 className="text-[48px] font-[200] text-navy-deep mb-4" data-id="element-199">
            Rozpočet a cena
          </h2>
          <p className="text-navy-deep/70 max-w-2xl mx-auto" data-id="element-200">
            Cena je tvořena rozpočítáním veškerých potřebných nákladů počtem
            startujících lodí (aktuálně počítáno pro 10 lodí). Splatnost celkové
            částky je do 1. 11. 2026.
          </p>
        </motion.div>

        <div className="bg-white rounded-2xl shadow-lg overflow-hidden" data-id="element-201">
          <div className="bg-navy-deep text-white p-8 text-center" data-id="element-202">
            <div className="text-sm font-medium tracking-wider uppercase mb-2 text-blue-sky" data-id="element-203">
              Cena na jednu posádku
            </div>
            <div className="text-5xl md:text-6xl font-bold mb-2" data-id="element-204">€4 790</div>
            <div className="text-white/70" data-id="element-205">Platba na EUR účet organizátora</div>
          </div>

          <div className="grid md:grid-cols-2 divide-y md:divide-y-0 md:divide-x divide-mist" data-id="element-206">
            {/* Zahrnuje */}
            <div className="p-8 md:p-10" data-id="element-207">
              <h3 className="text-xl font-semibold text-navy-deep mb-6 flex items-center gap-2" data-id="element-208">
                <CheckIcon className="w-6 h-6 text-green-500" data-id="element-209" />
                Cena zahrnuje
              </h3>
              <ul className="space-y-4" data-id="element-210">
                {['Pronájem lodě FIRST36 (15. - 22. května 2027)', 'Podíl na nákladech na pronájem rozhodcovské lodi', 'Poplatek za genaker', 'Pojištění kauce', 'Nejnutnější náklady na realizaci akce', 'Trička a vlajky', 'Ceny pro účastníky'].map((item, i) => <li key={i} className="flex items-start gap-3 text-navy-deep/80" data-id="element-211">
                    <div className="mt-1 w-1.5 h-1.5 rounded-full bg-blue-medium shrink-0" data-id="element-212" />
                    <span data-id="element-213">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* Nezahrnuje */}
            <div className="p-8 md:p-10 bg-mist/30" data-id="element-214">
              <h3 className="text-xl font-semibold text-navy-deep mb-6 flex items-center gap-2" data-id="element-215">
                <XIcon className="w-6 h-6 text-red-400" data-id="element-216" />
                Cena nezahrnuje
              </h3>
              <ul className="space-y-4" data-id="element-217">
                {['Dopravu z ČR do maríny', 'Poplatky za kotvení během plavby', 'Kauce za loď a genaker (2 200 € + 500 €)', 'Transit Log - úklid lodi (230 €)', 'Turistickou taxu (1,33 € os/den)', 'Stravování posádky', 'Projeté palivo do lodě'].map((item, i) => <li key={i} className="flex items-start gap-3 text-navy-deep/70" data-id="element-218">
                    <div className="mt-1 w-1.5 h-1.5 rounded-full bg-navy-deep/30 shrink-0" data-id="element-219" />
                    <span data-id="element-220">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="bg-mist p-6 text-sm text-navy-deep/70 flex gap-3 items-start" data-id="element-221">
            <InfoIcon className="w-5 h-5 text-blue-medium shrink-0" data-id="element-222" />
            <p data-id="element-223">
              Kauce je pojištěná v ceně lodi a bude po vrácení vyplacena zpět v
              plné výši. Pokud dojde k poškození, charterovka hradí škody z
              kauce a vy uplatníte doklad u pojišťovny.
            </p>
          </div>
        </div>
      </div>
    </section>;
}